import { CONTACT } from '../config';
import type { LegalBlock } from './legal-types';

export const legalEnBlocks: LegalBlock[] = [
  { type: 'section-title', text: 'PRIVACY POLICY' },
  { type: 'heading', text: '1. Introduction' },
  {
    type: 'paragraph',
    text: 'This Privacy Policy describes how “Shmatch P.C.” (“Shmatch”, “Company”, “we”) collects, uses, stores, and protects users’ personal data through its application and website.',
  },
  {
    type: 'paragraph',
    text: '“Shmatch” is committed to protecting personal data in accordance with:',
  },
  {
    type: 'list',
    items: [
      'Regulation (EU) 2016/679 (“GDPR”),',
      'applicable Greek legislation,',
      'and relevant European data protection regulations.',
    ],
  },
  { type: 'heading', text: '2. Data Controller Information' },
  { type: 'paragraph', text: 'Company Name: “Shmatch P.C.”' },
  { type: 'paragraph', text: ' Trade Name: “Shmatch”' },
  { type: 'paragraph', text: ' Registered Address: Vasilissis Olgas 24, Marousi, Attica, Greece' },
  { type: 'paragraph', text: 'GEMI Number: 187928603000' },
  { type: 'paragraph', text: 'VAT Number: 803036434' },
  { type: 'paragraph', text: `Contact Email: ${CONTACT.email}` },
  { type: 'paragraph', text: `Privacy Contact Email: ${CONTACT.privacyEmail}` },
  { type: 'heading', text: '3. Data We Collect' },
  { type: 'paragraph', text: '“Shmatch” may collect:' },
  {
    type: 'list',
    items: [
      'account information,',
      'booking information,',
      'payment-related information,',
      'device and technical information,',
      'analytics and usage data.',
    ],
  },
  { type: 'heading', text: '4. Purposes of Processing' },
  { type: 'paragraph', text: 'Personal data is processed for:' },
  {
    type: 'list',
    items: [
      'account management,',
      'booking services,',
      'customer support,',
      'analytics,',
      'platform improvement,',
      'fraud prevention,',
      'legal compliance,',
      'marketing communications where consent exists.',
    ],
  },
  { type: 'heading', text: '5. Legal Bases' },
  { type: 'paragraph', text: 'Processing is based on:' },
  {
    type: 'list',
    items: [
      'contract performance,',
      'user consent,',
      'legitimate interest,',
      'legal obligations.',
    ],
  },
  { type: 'heading', text: '6. Data Sharing' },
  { type: 'paragraph', text: '“Shmatch” may share data with:' },
  {
    type: 'list',
    items: [
      'cloud providers,',
      'payment processors,',
      'analytics providers,',
      'technical service providers,',
      'sports venues and partners.',
    ],
  },
  { type: 'heading', text: '7. International Transfers' },
  {
    type: 'paragraph',
    text: 'Where international transfers occur, “Shmatch” applies appropriate safeguards under GDPR.',
  },
  { type: 'heading', text: '8. User Rights' },
  { type: 'paragraph', text: 'Users have the right to:' },
  {
    type: 'list',
    items: [
      'access,',
      'rectification,',
      'erasure,',
      'restriction,',
      'portability,',
      'objection,',
      'withdraw consent.',
    ],
  },
  {
    type: 'route-link',
    before: 'To request erasure of your Shmatch account and associated personal data, use our ',
    linkText: 'account deletion request page',
    to: '/delete-account',
    after: `. You can also email ${CONTACT.privacyEmail}.`,
  },
  { type: 'heading', text: '9. Security Measures' },
  {
    type: 'paragraph',
    text: '“Shmatch” implements technical and organizational security measures to protect personal data.',
  },
  { type: 'section-title', text: 'COOKIE POLICY' },
  {
    type: 'paragraph',
    text: '“Shmatch” uses cookies and similar technologies to:',
  },
  {
    type: 'list',
    items: [
      'ensure platform functionality,',
      'analyze traffic,',
      'improve user experience,',
      'provide marketing and analytics services.',
    ],
  },
  { type: 'paragraph', text: 'Users may manage cookies through browser or platform settings.' },
  { type: 'section-title', text: 'TERMS & CONDITIONS' },
  { type: 'heading', text: '1. Scope' },
  { type: 'paragraph', text: 'These Terms govern the use of the “Shmatch” platform.' },
  { type: 'heading', text: '2. Platform Services' },
  {
    type: 'paragraph',
    text: '“Shmatch” operates as a digital platform connecting users with sports facilities and venues.',
  },
  { type: 'heading', text: '3. User Accounts' },
  {
    type: 'paragraph',
    text: 'Users must provide accurate information and maintain account confidentiality.',
  },
  { type: 'heading', text: '4. User Obligations' },
  { type: 'paragraph', text: 'Users agree not to:' },
  {
    type: 'list',
    items: [
      'misuse the platform,',
      'interfere with system operations,',
      'upload malicious software,',
      'violate third-party rights,',
      'engage in unlawful activity.',
    ],
  },
  { type: 'heading', text: '5. Intellectual Property' },
  {
    type: 'paragraph',
    text: 'All platform content and software are protected intellectual property of “Shmatch” or its licensors.',
  },
  { type: 'paragraph', text: 'Unauthorized use is prohibited.' },
  { type: 'heading', text: '6. Limitation of Liability' },
  { type: 'paragraph', text: '“Shmatch” is not liable for:' },
  {
    type: 'list',
    items: [
      'venue-related incidents,',
      'third-party actions,',
      'service interruptions,',
      'indirect damages,',
      'lost profits.',
    ],
  },
  { type: 'heading', text: '7. Suspension and Termination' },
  { type: 'paragraph', text: '“Shmatch” may suspend or terminate accounts violating these Terms.' },
  { type: 'heading', text: '8. Governing Law' },
  { type: 'paragraph', text: 'These Terms are governed by Greek and European law.' },
  { type: 'paragraph', text: 'Courts of Athens shall have exclusive jurisdiction.' },
];
